import { combineReducers } from "redux";
import resourcesReducer from "./resources/resourcesSlice";
import fileThumbnailsReducer from "./fileThumbnails/fileThumbnailsSlice";
import errorsReducer from "./errors/errorsSlice";
import resourceSearchReducer from "./resourceSearch/resourceSearchSlice";
import requestingReducer from "./requesting/requestingReducer";
import authReducer from "./auth/authSlice";

const rootReducer = combineReducers({
  resources: resourcesReducer,
  fileThumbnails: fileThumbnailsReducer,
  resourceSearch: resourceSearchReducer,
  errors: errorsReducer,
  requesting: requestingReducer,
  auth: authReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
